<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/03_Serre/03_1_Girifalco-Mongiana/03_1_Monte-Covello-Girifalco.jpg">
<div class="content">
    <h1>Serre</h1>
    <h3>Sulle strade della Ciclovia dei Parchi</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Regionale delle Serre</a> > <a class="active">Sulle strade della Ciclovia dei Parchi</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Girifalco-Serra San Bruno-Mongiana-Foresta Archiforo</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/03_Serre/03_1_Girifalco-Mongiana/03_1_Monte-Covello-Girifalco.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Questo itinerario che parte da Girifalco e raggiunge Serra San Bruno attraversa paesaggi molto vari, dai boschi fitti di Monte Covello,
             alle colline coltivate dei paesi che si avvicinano al mar Jonio, come san Vito, per poi riprendere la sua salita a Torre di Ruggiero, 
             alle porte del Parco delle Serre, e raggiungere lungo la Ciclovia dei Parchi il centro di Serra San Bruno (798 m). 
             Il paese ha un nucleo storico molto interessante dove è bene dedicarsi del tempo soprattutto per fare visita alla celebre Certosa di Santo Stefano.
            <br>
            <br>
            Nella seconda tappa, partendo dalla Certosa si prosegue verso Mongiana e di lì a poco, all’altezza di una edicola votiva, 
            occorre svoltare a sinistra risalendo sul sentiero che porta verso il bosco Archiforo, un sito dalla valenza naturalistica straordinaria che copre circa 4913 ettari.
             Si tratta di una delle testimonianze più significative dell’originario paesaggio delle Serre calabresi, 
             che consente di immergersi in una splendida foresta mista di abete bianco e faggio, con maestose pietre granitiche affioranti, 
             dove si trova l’Orto botanico Rosarella. La straordinarietà di questo habitat naturale trova riscontro anche nel lavoro del medico e 
             immunologo Qing Li che colloca il Bosco Archiforo tra i quaranta siti mondiali, solo due quelli individuati in Italia, ideali per lo Shinrin-Yoku, 
             il “bagno nella foresta”, altrimenti detto Silvoterapia o Forest bathing, 
             ovvero il metodo giapponese per trarre il massimo giovamento psicofisico dalla permanenza nella foresta, 
             per coltivare la felicità e vivere più a lungo. Saliti in cima al sentiero Archiforo il percorso ridiscende verso Mongiana. 
             Giunti in paese si scopre la storia di un’attività estrattiva che risale a tempi remoti in un territorio ricchissimo di risorse minerarie.
              Istituite da Ferdinando IV di Borbone, nella seconda metà del 1700, le Reali Ferriere e Officine, 
              la cui produzione fu molto incrementata nel periodo del Governo francese di Gioacchino Murat, 
              divennero infrastruttura strategica per la produzione di armi (celebre il fucile “Mongiana” e la sciabola fuori ordinanza premiata all’Esposizione 
              internazionale di Londra del 1862), ma anche e soprattutto per opere di ingegneria civile, come la ferrovia Napoli-Portici, 
              il ponte Real Ferdinando sul Garigliano e quello Maria Cristina sul Fiume Calore.
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici e a piedi</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>54,6 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1470 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1000 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Girifalco</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Mongiana</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-10 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Regionale delle Serre.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/Logo-Parco-1024x1024.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Serra San Bruno</h1>
                        <a (click)="goToLorica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Girifalco</h1>
                        <a (click)="goToArte()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
